// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.camera_cameras__th6Ag {
  width: 100%;
  height: 100%; }
  .camera_cameras__title__KXaor {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px; }
    .camera_cameras__title__KXaor h2 {
      font-weight: 600;
      font-size: 24px;
      line-height: 150%;
      color: var(--HightEmphasis); }
  .camera_cameras__desciption__XLv7U {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #666666; }
  .camera_cameras__name__sMBJB {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px; }
  .camera_cameras__list__qjwJ5 {
    margin-bottom: 50px; }
    .camera_cameras__list_delete__G5DSi {
      width: 20px;
      height: 20px;
      transition: all 0.4s;
      fill: #26272b; }
      .camera_cameras__list_delete__G5DSi:hover {
        fill: #fe6100; }
    .camera_cameras__list_image__gFxB9 {
      height: 70px;
      min-width: 120px;
      max-width: 120px;
      object-fit: contain; }
    .camera_cameras__list_item__k-RH- {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: 500;
      border-bottom: 1px solid #e0e0e0;
      cursor: pointer;
      color: #100f0f;
      text-decoration: none;
      transition: all 0.7s;
      border-radius: 6px; }
      .camera_cameras__list_item__k-RH- > div {
        padding: 20px 5px;
        display: flex;
        align-items: center;
        gap: 20px;
        width: 100%; }
      .camera_cameras__list_item__k-RH-:hover {
        background: rgba(254, 97, 0, 0.1); }
`, "",{"version":3,"sources":["webpack://./src/pages/camera/camera.module.scss","webpack://./src/styles/fonts.scss"],"names":[],"mappings":"AAEA;EACE,WAAW;EACX,YAAY,EAAA;EACZ;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB,EAAA;IAJpB;MCED,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MDGb,2BAA2B,EAAA;EAG/B;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc,EAAA;EAEhB;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB,EAAA;EAEnB;IACE,mBAAmB,EAAA;IACnB;MACE,WAAW;MACX,YAAY;MACZ,oBAAoB;MACpB,aAAa,EAAA;MAJd;QAMG,aAAa,EAAA;IAGjB;MACE,YAAY;MACZ,gBAAgB;MAChB,gBAAgB;MAChB,mBAAmB,EAAA;IAErB;MACE,aAAa;MACb,8BAA8B;MAC9B,mBAAmB;MACnB,gBAAgB;MAChB,gCAAgC;MAChC,eAAe;MACf,cAAc;MACd,qBAAqB;MACrB,oBAAoB;MACpB,kBAAkB,EAAA;MAVnB;QAaG,iBAAiB;QACjB,aAAa;QACb,mBAAmB;QACnB,SAAS;QACT,WAAW,EAAA;MAjBd;QAoBG,iCAAiC,EAAA","sourcesContent":["@import '../../styles/media.scss';\n@import '../../styles/fonts.scss';\n.cameras {\n  width: 100%;\n  height: 100%;\n  &__title {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 30px;\n    h2 {\n      @include h2;\n      color: var(--HightEmphasis);\n    }\n  }\n  &__desciption {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n    color: #666666;\n  }\n  &__name {\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 24px;\n  }\n  &__list {\n    margin-bottom: 50px;\n    &_delete {\n      width: 20px;\n      height: 20px;\n      transition: all 0.4s;\n      fill: #26272b;\n      &:hover {\n        fill: #fe6100;\n      }\n    }\n    &_image {\n      height: 70px;\n      min-width: 120px;\n      max-width: 120px;\n      object-fit: contain;\n    }\n    &_item {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      font-weight: 500;\n      border-bottom: 1px solid #e0e0e0;\n      cursor: pointer;\n      color: #100f0f;\n      text-decoration: none;\n      transition: all 0.7s;\n      border-radius: 6px;\n\n      > div {\n        padding: 20px 5px;\n        display: flex;\n        align-items: center;\n        gap: 20px;\n        width: 100%;\n      }\n      &:hover {\n        background: rgba(254, 97, 0, 0.1);\n      }\n    }\n  }\n}\n","@mixin h1 {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 150%;\n}\n\n@mixin h2 {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n}\n\n@mixin h3 {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n}\n\n@mixin h4 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin h5 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin h6 {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin body1 {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin body2 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n@mixin body3 {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n}\n\n@mixin link1 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin link2 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin caption {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n}\n\n@mixin title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin button {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cameras": `camera_cameras__th6Ag`,
	"cameras__title": `camera_cameras__title__KXaor`,
	"cameras__desciption": `camera_cameras__desciption__XLv7U`,
	"cameras__name": `camera_cameras__name__sMBJB`,
	"cameras__list": `camera_cameras__list__qjwJ5`,
	"cameras__list_delete": `camera_cameras__list_delete__G5DSi`,
	"cameras__list_image": `camera_cameras__list_image__gFxB9`,
	"cameras__list_item": `camera_cameras__list_item__k-RH-`
};
export default ___CSS_LOADER_EXPORT___;
